import React, { Component } from "react"
import styled from "styled-components"
import GoogleCalendarLogo from "../../images/google-calendar.png"
import { appStrings } from "../../common/strings/app_strings"
import { colors } from "../../common/colors/app_colors"
import { SelectTeamDropdownForm } from "../../common/components/select_team_dropdown"
import { GoogleCalendarSubtext } from "./google_calendar_subtext"
import { makeToast } from "../../util/toast_util"
import { GoogleCalendarConfigForm } from "./google_calendar_config_form"
import { GOOGLE_CALENDAR_INTEGRATION_URL } from "../../common/constants/app_consts"

const {
    googleCalendarHeader,
    googleCalendarAddNew,
    edit,
    cancel,
    connectToGoogle,
    selectTeamWarning,
    googleCalendarOverview,
} = appStrings.connectedApps

const { borderGray } = colors

export class GoogleCalendarItem extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pendingConfigFormOpen: false,
        }
    }
    componentDidUpdate(prevProps) {
        // if newly selected config, close pending config form
        if (!prevProps.selected && this.props.selected) {
            this.setState({ pendingConfigFormOpen: false })
        }
    }

    componentWillUnmount() {
        if (this.state.pendingConfigFormOpen) {
            this.setState({ pendingConfigFormOpen: false })
        }
    }

    startGoogleOauth = () => {
        const { pendingConfigTeamId, handleStartGoogleOauth } = this.props
        // only start oauth if there is a pending team
        if (pendingConfigTeamId) {
            handleStartGoogleOauth()
            return
        }
        makeToast(selectTeamWarning, "warning")
    }

    subtextConditionalRender = (config, team) => {
        const { selected } = this.props
        const configIsSelected = config && config.id === selected
        const teamName = team ? `🔗${team.isPersonal ? `${team.teamOwnerName} (you)` : team.name}` : ""

        if (this.state.pendingConfigFormOpen) {
            return (
                <GoogleCalendarSubtext
                    link={cancel}
                    clickFunction={this.handleHidePendingConfigForm}
                    arrowDirection={"up"}
                />
            )
        }
        if (!config) {
            return (
                <GoogleCalendarSubtext
                    link={googleCalendarAddNew}
                    clickFunction={this.handleShowPendingConfigForm}
                />
            )
        }
        if (configIsSelected) {
            return (
                <GoogleCalendarSubtext
                    clickFunction={() => this.handleSetSelectedConfigId(null)}
                    arrowDirection={"up"}
                    teamName={teamName}
                />
            )
        }
        if (config) {
            return (
                <GoogleCalendarSubtext
                    link={edit}
                    clickFunction={() =>
                        this.handleSetSelectedConfigId(config.id)
                    }
                    arrowDirection={"down"}
                    teamName={teamName}
                />
            )
        }
    }

    handleSetSelectedConfigId = id => {
        this.props.handleSelectGoogleCalendarConfig(id)
    }
    handleShowPendingConfigForm = () => {
        this.setState({ pendingConfigFormOpen: true })
        this.props.handleSelectGoogleCalendarConfig(null)
    }
    handleHidePendingConfigForm = () => {
        this.setState({ pendingConfigFormOpen: false })
    }
    removeAccount = (accountId, configId) => {
        this.props.handleRemoveAccount(accountId, configId)
    }
    removeCalendar = (calendarId, configId) => {
        this.props.handleRemoveCalendar(calendarId, configId)
    }
    selectTeam = id => {
        this.props.handleSetPendingConfigTeamId(id)
    }

    selectCalendar = ({ calendar }) => {
        const { id, gCalendarAccountId } = calendar
        const { handleAddNewCalendar, config } = this.props
        handleAddNewCalendar(config.id, gCalendarAccountId, id)
    }

    render() {
        const {
            config,
            team,
            selected,
            availableTeams,
            profile,
            pendingConfigTeamId,
            handleStartGoogleOauth,
            tags,
            handleSetDescription,
            handleUpdateTagKeywords,
            teams,
            handleUpdateConfigTags,
            handleUpdateAttendeeUsers,
            handleUpdateCreateAllDayRecords,
            handleUpdateCreateRecordsForMembers,
            handleDeleteConfig,
        } = this.props
        const configIsSelected = config && selected === config.id
        const { pendingConfigFormOpen } = this.state
        return (
            <ItemWrapper>
                <Item>
                    <img src={GoogleCalendarLogo} alt="Google Calendar Logo" />
                    <span className="title vertical-align">
                        {googleCalendarHeader}
                    </span>
                    {this.subtextConditionalRender(config, team)}
                </Item>
                {(pendingConfigFormOpen && !selected) && (
                    <div className="connected-apps-item-form-wrapper">
                        <div className="pending-config-group">
                            <p>
                                {googleCalendarOverview}
                                To learn more, click <a
                                    className="a-button"
                                    href={GOOGLE_CALENDAR_INTEGRATION_URL}
                                    target="_blank">here.</a>
                            </p>
                        </div>
                        <SelectTeamDropdownForm
                            availableTeams={availableTeams}
                            selectTeam={this.selectTeam}
                        ></SelectTeamDropdownForm>

                        {pendingConfigTeamId && (
                            <ConnectToGoogleWrapper>
                                <p>(2) Next, <span className={'link'} onClick={this.startGoogleOauth}>{connectToGoogle}</span>.</p>
                            </ConnectToGoogleWrapper>
                        )}
                    </div>
                )}
                {configIsSelected && (
                    <div className="connected-apps-item-form-wrapper">
                        <GoogleCalendarConfigForm
                            removeAccount={this.removeAccount}
                            removeCalendar={this.removeCalendar}
                            googleAccounts={config.gCalendarAccounts}
                            profile={profile}
                            config={config}
                            teamName={`🔗${team.isPersonal ? `${team.teamOwnerName} (you)` : team.name}`}
                            handleStartGoogleOauth={handleStartGoogleOauth}
                            handleSetDescription={handleSetDescription}
                            handleUpdateTagKeywords={handleUpdateTagKeywords}
                            handleUpdateConfigTags={handleUpdateConfigTags}
                            handleUpdateAttendeeUsers={handleUpdateAttendeeUsers}
                            handleUpdateCreateAllDayRecords={handleUpdateCreateAllDayRecords}
                            handleUpdateCreateRecordsForMembers={handleUpdateCreateRecordsForMembers}
                            handleDeleteConfig={handleDeleteConfig}
                            selectCalendar={this.selectCalendar}
                            teams={teams}
                            tags={tags}
                            team={team}
                        />
                    </div>
                )}
            </ItemWrapper>
        )
    }
}

const ConnectToGoogleWrapper = styled.div`
    padding-top: 18px;
`

const ItemWrapper = styled.div`
    border: 1px solid ${borderGray};
    margin: 0px 20px;
    border-radius: 4px;
    margin-bottom: 10px;
    .connected-apps-item-form-wrapper {
        border-top: 1px solid ${borderGray};
        padding: 2rem;
        .pending-config-group {
            display: flex;
            justify-content: space-between;
            .google-link {
                width: 200px;
                text-align: right;
            }
        }
    }
    img {
        height: 35px;
        width: 35px;
    }
`
const Item = styled.div`
    border-radius: 4px;
    display: flex;
    justify: center;
    padding: 10px 20px;
    .title {
        padding-left: 10px;
    }
    .vertical-align {
        margin-top: auto;
        margin-bottom: auto;
    }
    @media (max-width: 425px) {
        .title {
            display: none;
        }
        padding: 10px;
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/google_calendar_item.jsx